import { usePageContext } from '../components/PageContext'
import { useLocaleContext } from '../components/LocaleContext'
import { useLocationProvider } from '../components/LocationProvider/LocationProvider'
import { getBusinessMapping } from '@dfds-frontend/navigations'
import {
  trackingEnvironmentStore,
  buildLocalePayload,
} from '@dfds-frontend/tracking'

const usePageTrackingData = () => {
  const {
    slugId,
    pageTagging,
    pageTitle,
    statusCode,
    businessUnit,
    explicitTracking,
  } = usePageContext()
  const {
    locale,
    country: countryCode,
    language: languageCode,
  } = useLocaleContext()
  const { origin, pathname } = useLocationProvider()

  const pageRouteName =
    (pageTagging?.routeCode && pageTagging?.routeCode.split('.')[0]) ??
    undefined
  const pageRouteCode =
    (pageTagging?.routeCode && pageTagging?.routeCode.split('.')[1]) ??
    undefined
  const pageProductType = pageTagging?.product ?? undefined
  const pageType = pageTagging?.pageType ?? undefined

  // business unit logic
  const { businessType, businessDivision } = getBusinessMapping(businessUnit)

  // legacy props (to be deprecated)
  const legacyProps = {
    bookingEngine: 'dotcom',
    businessArea: businessUnit,
    contentfulId: slugId,
    contentfulMarker: locale,
    statusCode,
    currentLocale: locale,
    countryCode,
    languageCode,
    url: `${origin}${pathname}`,
    pagePath: pathname,
    pageTitle,
    pageRouteCode: pageRouteCode,
    pageRouteName: pageRouteName,
    pageProductType: pageProductType,
    pageType: pageType,
  }

  return {
    explicitTracking,
    getPageTrackingData: ({ vpvEvent = false } = {}) => {
      // Only return legacy props for non-VPV events
      if (!vpvEvent) {
        return legacyProps
      }

      const engagement = {
        entity: 'user',
        category: 'unclassified',
        action: 'view',
      }

      const environment = {
        business_type: businessType,
        business_division: businessDivision,
        business_application: 'DOTCOM',
        ...buildLocalePayload(locale),
        contentful_id: slugId,
      }
      trackingEnvironmentStore.set(environment)

      const content = {
        type: 'unclassified',
      }

      const properties = {
        url: legacyProps.url,
        page_path: legacyProps.pagePath,
        page_title: legacyProps.pageTitle,
        status_code: parseInt(legacyProps.statusCode) || 200,
      }

      return {
        ...legacyProps,
        engagement,
        environment,
        content,
        properties,
      }
    },
  }
}

export default usePageTrackingData
